import { render, staticRenderFns } from "./ChunkText.vue?vue&type=template&id=3eb7e48c&scoped=true"
import script from "./ChunkText.vue?vue&type=script&lang=js"
export * from "./ChunkText.vue?vue&type=script&lang=js"
import style0 from "./ChunkText.vue?vue&type=style&index=0&id=3eb7e48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb7e48c",
  null
  
)

export default component.exports